const data = [
  { year: 1990, percent: 10, number: 195 },
  { year: 1992, percent: 12, number: 247 },
  { year: 1994, percent: 15, number: 279 },
  { year: 1996, percent: 14, number: 248 },
  { year: 1998, percent: 16, number: 279 },
  { year: 2000, percent: 19, number: 342 },
  { year: 2002, percent: 18, number: 369 },
  { year: 2004, percent: 20.8, number: 409 },
  { year: 2006, percent: 19, number: 395 },
  { year: 2008, percent: 21.2, number: 469 },
  { year: 2010, percent: 23.6, number: 497 },
];

export default data;
